import React from 'react';
import { useStore } from '../../contexts/StoreContext';
import { images } from '../../data/images';
export function Logo({
  showTagline = true
}: {
  showTagline?: boolean;
}) {
  const {
    settings
  } = useStore();
  if (settings.logoUrl) {
    return <img src={settings.logoUrl} alt="VCARS" className="h-10 w-auto max-w-[160px] object-contain" data-id="element-922" data-mp="t9yrx6csil3g" />;
  }
  return <span className="flex items-center gap-2.5" data-id="element-923" data-mp="of2xy0nztnnp">
      <img src={images.logo} alt="VCARS" className="h-11 w-11 object-cover" style={{
      clipPath: 'circle(48.6% at 50% 50%)'
    }} data-id="element-924" data-mp="kc6lyssykpsq" />
      {showTagline && <span className="hidden whitespace-nowrap text-xs font-bold tracking-[0.18em] text-mist sm:block" data-id="element-925" data-mp="fik50ofrhzr4">
          <span className="text-white" data-id="element-926" data-mp="5m8ua2vtlhys">VCARS</span> - 0KM MULTIMARCAS
        </span>}
    </span>;
}